import React, { useState, useEffect, useRef, useContext } from "react";
import axios from "axios";
import URLAPI from "../../helpers/Path";
import { MDBInput, MDBRow, MDBCol, MDBTextArea } from "mdb-react-ui-kit";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { ClienteContext } from "../context/clientscontext.jsx";

import {
  AutoComplete_Create,
  AutoComplete_Destroy,
} from "../js/AutoComplete.js";

const ConsultC = () => {
  //Endpoint para obtener todos los clientes
  const clientesphp = URLAPI + "trae_clientes.php";
  //Endpoint para obtener información del cliente seleccionado
  const clientesearchphp = URLAPI + "info_cliente.php";

  //Enpoint para obtener los archivos del cliente seleccionado
  const obtener_archivos = URLAPI + "archivos_cliente.php";

  //Traigo los catalogos de nacionalidad, estado civil, regimen fiscal y pais
  const id_nacionalidadPhp = URLAPI + "lista_nacionalidad.php";
  const id_estadoPhp = URLAPI + "lista_estado.php";
  const id_regimenPhp = URLAPI + "lista_regimen.php";
  const id_regimen_fiscalPhp = URLAPI + "lista_regimen_fiscal.php";
  const id_lista_paisPhp = URLAPI + "lista_pais.php";
  // --------------------------------------------------------------------------------------------------

  //Variable de estado en los que se insertar los archivos y las selecciones de los diferentes selects
  const [archive, setArchive] = useState([]);
  //Estado que guardara todos los clientes
  const [clientes, setClientes] = useState([]);
   //Estado que guardara el nombre de la busqueda realizada
  const [busqueda, setBusqueda] = useState("");
    //Estado que guardara el id del cliente seleccionado
  const [idcliente, setIdcliente] = useState("");
  const [datosCliente, setDatosCliente] = useState({});
  const [nacionalidades, setnacionalidades] = useState([]);
  const [estados, setestados] = useState([]);
  const [regimenes, setregimenes] = useState([]);
  const [regimenes_fiscales, setregimenes_fiscales] = useState([]);
  const [paises, setPaises] = useState([]);
  //------------------------------------------------------------------------------------------------------------------

  //Referencia para el autocompletado
  const inputRef = useRef(null);
  // -------------------------------------------------------------------------------------------------------------------

  //Obtenemos el id del cliente
  const { setIdClienteSeleccionado } = useContext(ClienteContext);

  // -------------------------------------------------------------------------------------------------------------------------

  //Este useEffect se encarga de obtener todos los clientes desde el backend
  //Inicializa un autocompletado con hasta 10 clientes maximo

  useEffect(() => {
    const getClientes = async () => {
      try {
        const res = await axios.get(clientesphp);
        const clientesArray = Object.entries(res.data).map(([id, nombre]) => ({
          id,
          nombre,
        }));
        setClientes(clientesArray);

        if (inputRef.current) {
          AutoComplete_Create(inputRef.current.id, clientesArray, 10); // 10 clientes maximo
        }
      } catch (error) {
        console.error("Error al obtener clientes:", error);
      }
    };

    getClientes();
    //Al desmontar el componente, este se destruye
    return () => {
      if (inputRef.current) {
        AutoComplete_Destroy(inputRef.current.id);
      }
    };
  }, []);
  // --------------------------------------------------------------------------------------------------

  //Usamos useEffect para obtener los datos de nacionalidad, estado civil, regimen fiscal y pais

  useEffect(() => {
    const getnacionalidad = async () => {
      try {
        const res = await axios.get(id_nacionalidadPhp);
        setnacionalidades(res.data); // Guardamos el arreglo completo
        //console.log("ver nacionalidad ", res.data); // Para ver todas las nacionalidades
      } catch (error) {
        console.error("No se hizo la conexion", error);
      }
    };
    getnacionalidad();
  }, []);

  useEffect(() => {
    const getestado = async () => {
      try {
        const res = await axios.get(id_estadoPhp);
        setestados(res.data);
        //console.log("ver estados ", res.data); // Para ver todas los estados civiles
      } catch (error) {
        console.error("No se hizo la conexion", error);
      }
    };
    getestado();
  }, []);

  useEffect(() => {
    const getregimen = async () => {
      try {
        const res = await axios.get(id_regimenPhp);
        setregimenes(res.data);
      } catch (error) {
        console.error("No se hizo la conexion", error);
      }
    };
    getregimen();
  }, []);

  useEffect(() => {
    const getregimen_fiscal = async () => {
      try {
        const res = await axios.get(id_regimen_fiscalPhp);
        setregimenes_fiscales(res.data);
      } catch (error) {
        console.error("No se hizo la conexion", error);
      }
    };
    getregimen_fiscal();
  }, []);

  useEffect(() => {
    const getlista_pais = async () => {
      try {
        const res = await axios.get(id_lista_paisPhp);
        setPaises(res.data);
      } catch (error) {
        console.error("No se hizo la conexión con la lista de paises", error);
      }
    };
    getlista_pais();
  }, []);
  // --------------------------------------------------------------------------------------------------------

  // Maneja la selección del autocomplete
  useEffect(() => {
    if (!inputRef.current) return;

    const handleSelect = async () => {
      setTimeout(async () => {
        const idSeleccionado = inputRef.current.dataset.id; // ID del cliente seleccionado
        const nombreSeleccionado = inputRef.current.value; // Nombre mostrado en el input

        if (idSeleccionado) {
          //console.log("📌 ID seleccionado:", idSeleccionado);
          setIdcliente(idSeleccionado);
          setBusqueda(nombreSeleccionado);
//Obtener e insertar información del cliente seleccionado
          try {
            const res = await axios.post(clientesearchphp, {
              data: idSeleccionado,
            });
            // console.log("Datos de la cuenta:", res.data);

            setIdClienteSeleccionado(idSeleccionado);
            setDatosCliente(res.data);
            //setArchive(res.data.archivos)

            const archivos = await axios.post(obtener_archivos, {
              id_seleccionado: idSeleccionado,
            });

           // console.log("archivos del cliente:", archivos);

            if (archivos) {
              const archivosArray = Object.values(archivos.data);
              setArchive(archivosArray);
              //console.log("archivo mandado", archivos);
              //console.log("archivo dividido", archivosArray);
            }
          } catch (error) {
            console.error("Error recuperando datos:", error);
          }
        }
      }, 0);
    };

// --------------------------------------------------------------------------------------------------------------
// Escucha teclas enter o space y la selección de texto en un input y llama a la función handleselect donde se obtiene la información de ese cliente
    const handleKeyDown = (e) => {
      if (e.code === "Space" || e.code === "Enter") {
        e.preventDefault();
        handleSelect();
      }
    };

    inputRef.current.addEventListener("keydown", handleKeyDown);
    inputRef.current.addEventListener("select", handleSelect);
//Cuando se desmonta el componente, quita los listener para evitar problemas
    return () => {
      if (inputRef.current) {
        inputRef.current.removeEventListener("change", handleSelect);
      }
    };
  }, [clientes, clientesearchphp]);
  // --------------------------------------------------------------------------------------------------------------------



  //Función que determina si el archivo expiro o no
  const file_date = (vigencia, fecha_carga) => {
    const vigencia_number = Number(vigencia);
    // Fecha actual
    const fecha_actual = new Date();

     //console.log("Fecha actual:", fecha_actual);

    // Convertimos fecha de carga a Date
    const partes = fecha_carga.split("-");
    const fechaObj = new Date(partes[0], partes[1] - 1, partes[2]);

     //console.log("Fecha de carga del archivo:", fechaObj);

    // Sumamos vigencia en meses
    fechaObj.setMonth(fechaObj.getMonth() + vigencia_number);

    // console.log("Vigencia en meses:", vigencia_number);

    // console.log("Fecha límite del archivo:", fechaObj);

    // Comparación
    return fechaObj < fecha_actual;
  };
  // -----------------------------------------------------------------------------------------------------------

  // Busca en los array de los select, el id que coincide con su seleccion

  const nacionalidadTexto =
    nacionalidades.find(
      (nac) => nac.id_nacionalidad === datosCliente.id_nacionalidad
    )?.nacionalidad || "";

  const estadoCivilTexto =
    estados.find((est) => est.id_estado === datosCliente.id_estado)?.estado ||
    "";

  const regimenTexto =
    regimenes.find((reg) => reg.id_regimen === datosCliente.id_regimen)
      ?.regimen || "";

  const paisTexto =
    paises.find((pais) => pais.id_pais === datosCliente.id_pais)?.pais || "";

  const id_regimen_fiscalTexto =
    regimenes_fiscales.find(
      (regf) => regf.id_regimen_fiscal === datosCliente.id_regimen_fiscal
    )?.regimen_fiscal || "";
    // --------------------------------------------------------------------------------------------

  return (
    <div>
      <hr />
      <h5 className="mt-3">Consultar la información de los clientes</h5>
      <p>
        Para consultar la información del cliente, realize la busqueda
        comenzando por el apellido paterno, luego el materno y a final el
        nombre.
      </p>
      <MDBRow>
        <MDBCol>
          <MDBInput
            id="clienteInput"
            ref={inputRef}
            type="text"
            value={busqueda}
            onChange={(e) => setBusqueda(e.target.value)}
            label="Ap. paterno, Ap. materno, Nombre"
            wrapperClass="w-100"
          />
          <MDBInput
            type="text"
            placeholder="ID Cliente"
            style={{
              padding: "5px",
              width: "100px",
              marginLeft: "10px",
              display: "none",
            }}
            value={idcliente}
            readOnly
          />
        </MDBCol>
      </MDBRow>

      {/* Persona física */}
      {datosCliente.tipo_cliente === "1" && (
        <div className="mt-4">
          <MDBRow>
            <MDBCol>
              <MDBInput
                label="Nombre(s)"
                type="text"
                value={datosCliente.nombre || ""}
                readOnly
              />
            </MDBCol>
          </MDBRow>

          <MDBRow className="mt-3">
            <MDBCol>
              <MDBInput
                label="Apellido paterno"
                type="text"
                value={datosCliente.ap_paterno || ""}
                readOnly
              />
            </MDBCol>
            <MDBCol>
              <MDBInput
                label="Apellido materno"
                type="text"
                value={datosCliente.ap_materno || ""}
                readOnly
              />
            </MDBCol>
          </MDBRow>

          <MDBRow className="mt-3">
            <MDBCol>
              <MDBInput
                label="También conocido como"
                type="text"
                value={datosCliente.tambien_conocido || ""}
                readOnly
              />
            </MDBCol>
          </MDBRow>
          <MDBRow className="mt-3">
            <MDBCol>
              <MDBInput
                label="Nacionalidad"
                type="text"
                value={nacionalidadTexto}
                readOnly
              />
            </MDBCol>

            <MDBCol>
              <DatePicker
                selected={
                  datosCliente.fecha_nacimiento
                    ? (() => {
                        const parts = datosCliente.fecha_nacimiento.split("-");
                        return new Date(parts[0], parts[1] - 1, parts[2]); // fecha local sin desfase
                      })()
                    : null
                }
                onChange={() => {}} // no hace nada porque está disabled
                dateFormat="yyyy-MM-dd"
                placeholderText="Fecha de nacimiento"
                className="form-control"
                wrapperClassName="w-100"
                disabled
              />
            </MDBCol>
          </MDBRow>

          <MDBRow className="mt-3">
            <MDBCol>
              <MDBInput
                label="Lugar de nacimiento"
                type="text"
                value={datosCliente.lugar_nacimiento || ""}
                readOnly
              />
            </MDBCol>
          </MDBRow>

          <MDBRow className="mt-3">
            <MDBCol>
              <MDBInput
                label="Ocupación"
                type="text"
                value={datosCliente.ocupacion || ""}
                readOnly
              />
            </MDBCol>
          </MDBRow>

          <MDBRow className="mt-3">
            <MDBCol>
              <MDBInput
                label="C.U.R.P."
                type="text"
                value={datosCliente.curp || ""}
                readOnly
              />
            </MDBCol>

            <MDBCol>
              <MDBInput
                label="R.F.C."
                type="text"
                value={datosCliente.rfc || ""}
                readOnly
              />
            </MDBCol>
          </MDBRow>

          <MDBRow className="mt-3">
            <MDBCol>
              <MDBInput
                label="Estado civil"
                type="text"
                value={estadoCivilTexto}
                readOnly
              />
            </MDBCol>

            <MDBCol>
              <MDBInput
                label="Régimen matrimonial"
                type="text"
                value={regimenTexto}
                readOnly
              />
            </MDBCol>
          </MDBRow>

          <MDBRow className="mt-3">
            <MDBCol>
              <MDBInput
                label="Régimen fiscal"
                type="text"
                value={id_regimen_fiscalTexto}
                readOnly
              />
            </MDBCol>
          </MDBRow>
        </div>
      )}

      {/* Persona moral */}
      {datosCliente.tipo_cliente === "2" && (
        <div className="mt-4">
          <MDBRow>
            <MDBCol>
              <MDBInput
                label="Razón social"
                type="text"
                value={datosCliente.razon_social || ""}
                readOnly
              />
            </MDBCol>
          </MDBRow>

          <MDBRow className="mt-3">
            <MDBCol>
              <MDBInput
                label="Representante legal"
                type="text"
                value={datosCliente.representante || ""}
                readOnly
              />
            </MDBCol>
            <MDBCol>
              <MDBInput
                label="RFC"
                type="text"
                value={datosCliente.rfc || ""}
                readOnly
              />
            </MDBCol>
          </MDBRow>

          <MDBRow className="mt-3">
            <MDBCol>
              <MDBInput
                label="Régimen fiscal"
                type="text"
                value={id_regimen_fiscalTexto}
                readOnly
              />
            </MDBCol>
          </MDBRow>
        </div>
      )}

      {datosCliente.tipo_cliente && (
        <>
          {/* Domicilio */}
          <div className="fieldset-container">
            <span className="fieldset-title">Domicilio</span>
            <MDBRow className="mt-3">
              <MDBCol>
                <MDBInput
                  label="Calle"
                  type="text"
                  value={datosCliente.calle || ""}
                  readOnly
                />
              </MDBCol>
            </MDBRow>
            <MDBRow className="mt-3">
              <MDBCol>
                <MDBInput
                  label="No. Exterior"
                  type="text"
                  value={datosCliente.numero_exterior || ""}
                  readOnly
                />
              </MDBCol>

              <MDBCol>
                <MDBInput
                  label="No. Interior"
                  type="text"
                  value={datosCliente.numero_interior || ""}
                  readOnly
                />
              </MDBCol>
            </MDBRow>
            <MDBRow className="mt-3">
              <MDBCol>
                <MDBInput
                  label="Colonia"
                  type="text"
                  value={datosCliente.colonia || ""}
                  readOnly
                />
              </MDBCol>
            </MDBRow>

            <MDBRow className="mt-3">
              <MDBCol>
                <MDBInput
                  label="Localidad"
                  type="text"
                  value={datosCliente.localidad || ""}
                  readOnly
                />
              </MDBCol>
              <MDBCol>
                <MDBInput
                  label="Ciudad"
                  type="text"
                  value={datosCliente.ciudad || ""}
                  readOnly
                />
              </MDBCol>
            </MDBRow>

            <MDBRow className="mt-3">
              <MDBCol>
                <MDBInput
                  label="Estado"
                  type="text"
                  value={datosCliente.estado || ""}
                  readOnly
                />
              </MDBCol>
              <MDBCol>
                <MDBInput label="País" type="text" value={paisTexto} readOnly />
              </MDBCol>
            </MDBRow>

            <MDBRow className="mt-3">
              <MDBCol>
                <MDBInput
                  label="CP"
                  type="text"
                  value={datosCliente.cp || ""}
                  readOnly
                />
              </MDBCol>
            </MDBRow>
          </div>
        </>
      )}

      {datosCliente.tipo_cliente && (
        <>
          {/* Contacto */}
          <div className="fieldset-container">
            <span className="fieldset-title">Contacto</span>
            <MDBRow className="mt-3">
              <MDBCol>
                <MDBInput
                  label="Teléfono particular"
                  type="text"
                  value={datosCliente.telefono_particular || ""}
                  readOnly
                />
              </MDBCol>
              <MDBCol>
                <MDBInput
                  label="Teléfono oficina"
                  type="text"
                  value={datosCliente.telefono_oficina || ""}
                  readOnly
                />
              </MDBCol>
            </MDBRow>

            <MDBRow className="mt-3">
              <MDBCol>
                <MDBInput
                  label="Teléfono móvil"
                  type="text"
                  value={datosCliente.telefono_movil || ""}
                  readOnly
                />
              </MDBCol>
              <MDBCol>
                <MDBInput
                  label="Correo electrónico"
                  type="text"
                  value={datosCliente.mail || ""}
                  readOnly
                />
              </MDBCol>
            </MDBRow>

            <MDBRow className="mt-3">
              <MDBCol>
                <MDBTextArea
                  label="Observaciones generales"
                  value={datosCliente.observaciones || ""}
                  readOnly
                />
              </MDBCol>
            </MDBRow>
          </div>

          <div className="fieldset-container">
            <span className="fieldset-title">Archivos</span>
            <div>
              <table className="table-auto border-collapse border border-gray-400 w-full ">
                <thead>
                  <tr className="bg-gray-200 bg-warning">
                    <th
                      style={{
                        width: "600px",
                        height: "50px",
                        color: "white",
                        textIndent: "22px",
                      }}
                    >
                      &nbsp;Nombre
                    </th>
                    <th
                      style={{
                        width: "200px",
                        height: "50px",
                        color: "white",
                        textAlign: "center",
                      }}
                    >
                      Fecha de carga
                    </th>
                    <th
                      style={{
                        width: "200px",
                        height: "50px",
                        color: "white",
                        textAlign: "center",
                      }}
                    >
                      Vigencia en meses
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {archive.map((archivo, index) => {
                    const expirar = file_date(
                      archivo.vigencia,
                      archivo.fecha_carga
                    );

                    return (
                      <tr
                        key={archivo.id || index}
                        style={{
                          backgroundColor: expirar ? "#fe8484ff" : "#ffffff",
                        }}
                      >
                        <td className="border border-gray-400 px-4 py-2">
                          <a
                            style={{
                              color: "#000000ff",
                              textDecoration: "underline",
                              cursor: "pointer",
                              padding: "4px",
                              textDecoration: "none",
                            }}
                            href={`https://n4col.com/docs/${archivo.nombre}`}
                            target="_blank"
                          >
                            {archivo.nombre}
                          </a>
                        </td>
                        <td
                          className="border border-gray-400 px-4 py-2"
                          style={{ textAlign: "center" }}
                        >
                          {archivo.fecha_carga}
                        </td>
                        <td
                          className="border border-gray-400 px-4 py-2 "
                          style={{ textAlign: "center" }}
                        >
                          {archivo.vigencia}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>
        </>
      )}

      <MDBRow className="d-flex justify-content-between align-items-center my-4">
        <MDBCol className="col-auto">
          <button
            className="btn btn-warning"
            onClick={() => window.location.reload()}
            style={{
              borderRadius: "8px",
              fontWeight: "bold",
            }}
          >
            ⟵
          </button>
        </MDBCol>
      </MDBRow>
    </div>
  );
};

export default ConsultC;
